"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformPolicyPermissionsAsset = exports.SdPlatformPolicyPermissionsPlatform = exports.SdPlatformPolicyPermissionsUtility = exports.SdPlatformPolicyPermissionsSavedState = exports.SdPlatformPolicyPermissionsUser = exports.SdPlatformPolicyPermissionsOrganization = exports.SdPlatformPolicyPermissionsModel = exports.SdPlatformPolicyCommonAliasesAsset = exports.SdPlatformPolicyCommonAliasesPlatform = exports.SdPlatformPolicyCommonAliasesUtility = exports.SdPlatformPolicyCommonAliasesOrganization = exports.SdPlatformPolicyCommonAliasesUser = exports.SdPlatformPolicyCommonAliasesSavedState = exports.SdPlatformPolicyCommonAliasesModel = exports.SdPlatformPolicyPermissionStatus = exports.SdPlatformPolicyType = void 0;
/**
 * Types of policies
 */
var SdPlatformPolicyType;
(function (SdPlatformPolicyType) {
    SdPlatformPolicyType["ModelPolicy"] = "ModelPolicy";
    SdPlatformPolicyType["OrganizationPolicy"] = "OrganizationPolicy";
    SdPlatformPolicyType["UserPolicy"] = "UserPolicy";
    SdPlatformPolicyType["SavedStatePolicy"] = "SavedStatePolicy";
    SdPlatformPolicyType["UtilityPolicy"] = "UtilityPolicy";
    SdPlatformPolicyType["PlatformPolicy"] = "PlatformPolicy";
    SdPlatformPolicyType["AssetPolicy"] = "AssetPolicy";
})(SdPlatformPolicyType = exports.SdPlatformPolicyType || (exports.SdPlatformPolicyType = {}));
/**
 * Permission status values
 */
var SdPlatformPolicyPermissionStatus;
(function (SdPlatformPolicyPermissionStatus) {
    /** permission not granted */
    SdPlatformPolicyPermissionStatus["NoPermission"] = "no_permission";
    /** permission granted */
    SdPlatformPolicyPermissionStatus["Allowed"] = "allowed";
    /** permission explicitely denied */
    SdPlatformPolicyPermissionStatus["Denied"] = "denied";
})(SdPlatformPolicyPermissionStatus = exports.SdPlatformPolicyPermissionStatus || (exports.SdPlatformPolicyPermissionStatus = {}));
/**
 * Common policy aliases - Models
 */
var SdPlatformPolicyCommonAliasesModel;
(function (SdPlatformPolicyCommonAliasesModel) {
    SdPlatformPolicyCommonAliasesModel["AdminModelPolicy"] = "AdminModelPolicy";
    SdPlatformPolicyCommonAliasesModel["OrgManagerModelPolicyAnalyticsComputation"] = "OrgManagerModelPolicyAnalyticsComputation";
    SdPlatformPolicyCommonAliasesModel["OrgManagerModelPolicyAnalyticsSession"] = "OrgManagerModelPolicyAnalyticsSession";
    SdPlatformPolicyCommonAliasesModel["OrgManagerModelPolicyBackendApi"] = "OrgManagerModelPolicyBackendApi";
    SdPlatformPolicyCommonAliasesModel["OrgManagerModelPolicyDesktopClients"] = "OrgManagerModelPolicyDesktopClients";
    SdPlatformPolicyCommonAliasesModel["OrgManagerModelPolicyDirectEmbedding"] = "OrgManagerModelPolicyDirectEmbedding";
    SdPlatformPolicyCommonAliasesModel["OrgManagerModelPolicyExport"] = "OrgManagerModelPolicyExport";
    SdPlatformPolicyCommonAliasesModel["OrgManagerModelPolicyIframeEmbedding"] = "OrgManagerModelPolicyIframeEmbedding";
    SdPlatformPolicyCommonAliasesModel["OrgManagerModelPolicySavedStates"] = "OrgManagerModelPolicySavedStates";
    SdPlatformPolicyCommonAliasesModel["OrgManagerModelPolicyUnlistedModels"] = "OrgManagerModelPolicyUnlistedModels";
    SdPlatformPolicyCommonAliasesModel["OrgManagerModelPolicyView"] = "OrgManagerModelPolicyView";
    SdPlatformPolicyCommonAliasesModel["OrgMemberModelPolicyExport"] = "OrgMemberModelPolicyExport";
    SdPlatformPolicyCommonAliasesModel["OrgMemberModelPolicyView"] = "OrgMemberModelPolicyView";
    SdPlatformPolicyCommonAliasesModel["OwnedModelPolicyAnalyticsComputation"] = "OwnedModelPolicyAnalyticsComputation";
    SdPlatformPolicyCommonAliasesModel["OwnedModelPolicyAnalyticsSession"] = "OwnedModelPolicyAnalyticsSession";
    SdPlatformPolicyCommonAliasesModel["OwnedModelPolicyBackendApi"] = "OwnedModelPolicyBackendApi";
    SdPlatformPolicyCommonAliasesModel["OwnedModelPolicyDesktopClients"] = "OwnedModelPolicyDesktopClients";
    SdPlatformPolicyCommonAliasesModel["OwnedModelPolicyDirectEmbedding"] = "OwnedModelPolicyDirectEmbedding";
    SdPlatformPolicyCommonAliasesModel["OwnedModelPolicyExport"] = "OwnedModelPolicyExport";
    SdPlatformPolicyCommonAliasesModel["OwnedModelPolicyIframeEmbedding"] = "OwnedModelPolicyIframeEmbedding";
    SdPlatformPolicyCommonAliasesModel["OwnedModelPolicySavedStates"] = "OwnedModelPolicySavedStates";
    SdPlatformPolicyCommonAliasesModel["OwnedModelPolicyUnlistedModels"] = "OwnedModelPolicyUnlistedModels";
    SdPlatformPolicyCommonAliasesModel["OwnedModelPolicyView"] = "OwnedModelPolicyView";
    SdPlatformPolicyCommonAliasesModel["PrivateLinkSharedModelPolicyExport"] = "PrivateLinkSharedModelPolicyExport";
    SdPlatformPolicyCommonAliasesModel["PrivateLinkSharedModelPolicyView"] = "PrivateLinkSharedModelPolicyView";
    SdPlatformPolicyCommonAliasesModel["PublicModelPolicyExport"] = "PublicModelPolicyExport";
    SdPlatformPolicyCommonAliasesModel["PublicModelPolicyView"] = "PublicModelPolicyView";
    SdPlatformPolicyCommonAliasesModel["SharedModelPolicyAnalyticsComputation"] = "SharedModelPolicyAnalyticsComputation";
    SdPlatformPolicyCommonAliasesModel["SharedModelPolicyAnalyticsSession"] = "SharedModelPolicyAnalyticsSession";
    SdPlatformPolicyCommonAliasesModel["SharedModelPolicyBackendApi"] = "SharedModelPolicyBackendApi";
    SdPlatformPolicyCommonAliasesModel["SharedModelPolicyDesktopClients"] = "SharedModelPolicyDesktopClients";
    SdPlatformPolicyCommonAliasesModel["SharedModelPolicyDirectEmbedding"] = "SharedModelPolicyDirectEmbedding";
    SdPlatformPolicyCommonAliasesModel["SharedModelPolicyDownload"] = "SharedModelPolicyDownload";
    SdPlatformPolicyCommonAliasesModel["SharedModelPolicyExport"] = "SharedModelPolicyExport";
    SdPlatformPolicyCommonAliasesModel["SharedModelPolicyIframeEmbedding"] = "SharedModelPolicyIframeEmbedding";
    SdPlatformPolicyCommonAliasesModel["SharedModelPolicyQuery"] = "SharedModelPolicyQuery";
    SdPlatformPolicyCommonAliasesModel["SharedModelPolicySavedStates"] = "SharedModelPolicySavedStates";
    SdPlatformPolicyCommonAliasesModel["SharedModelPolicyUnlistedModels"] = "SharedModelPolicyUnlistedModels";
    SdPlatformPolicyCommonAliasesModel["SharedModelPolicyView"] = "SharedModelPolicyView";
})(SdPlatformPolicyCommonAliasesModel = exports.SdPlatformPolicyCommonAliasesModel || (exports.SdPlatformPolicyCommonAliasesModel = {}));
/**
 * Common policy aliases - Saved states
 */
var SdPlatformPolicyCommonAliasesSavedState;
(function (SdPlatformPolicyCommonAliasesSavedState) {
    SdPlatformPolicyCommonAliasesSavedState["AdminSavedStatePolicy"] = "AdminSavedStatePolicy";
    SdPlatformPolicyCommonAliasesSavedState["OrgManagerSavedStatePolicy"] = "OrgManagerSavedStatePolicy";
    SdPlatformPolicyCommonAliasesSavedState["OrgMemberSavedStatePolicyView"] = "OrgMemberSavedStatePolicyView";
    SdPlatformPolicyCommonAliasesSavedState["OwnedSavedStatePolicy"] = "OwnedSavedStatePolicy";
    SdPlatformPolicyCommonAliasesSavedState["PublicSavedStatePolicyView"] = "PublicSavedStatePolicyView";
    SdPlatformPolicyCommonAliasesSavedState["SharedSavedStatePolicyMinimal"] = "SharedSavedStatePolicyMinimal";
    SdPlatformPolicyCommonAliasesSavedState["SharedSavedStatePolicyView"] = "SharedSavedStatePolicyView";
})(SdPlatformPolicyCommonAliasesSavedState = exports.SdPlatformPolicyCommonAliasesSavedState || (exports.SdPlatformPolicyCommonAliasesSavedState = {}));
/**
 * Common policy aliases - Users
 */
var SdPlatformPolicyCommonAliasesUser;
(function (SdPlatformPolicyCommonAliasesUser) {
    SdPlatformPolicyCommonAliasesUser["AdminUserPolicy"] = "AdminUserPolicy";
    SdPlatformPolicyCommonAliasesUser["SelfUserPolicy"] = "SelfUserPolicy";
    SdPlatformPolicyCommonAliasesUser["PublicUserPolicy"] = "PublicUserPolicy";
    SdPlatformPolicyCommonAliasesUser["LoggedInUserPolicy"] = "LoggedInUserPolicy";
    SdPlatformPolicyCommonAliasesUser["MinimalUserPolicy"] = "MinimalUserPolicy";
})(SdPlatformPolicyCommonAliasesUser = exports.SdPlatformPolicyCommonAliasesUser || (exports.SdPlatformPolicyCommonAliasesUser = {}));
/**
 * Common policy aliases - Organizations
 */
var SdPlatformPolicyCommonAliasesOrganization;
(function (SdPlatformPolicyCommonAliasesOrganization) {
    SdPlatformPolicyCommonAliasesOrganization["AdminOrgPolicy"] = "AdminOrgPolicy";
    SdPlatformPolicyCommonAliasesOrganization["OrgAdminOrgPolicy"] = "OrgAdminOrgPolicy";
    SdPlatformPolicyCommonAliasesOrganization["OrgManagerOrgPolicy"] = "OrgManagerOrgPolicy";
    SdPlatformPolicyCommonAliasesOrganization["OrgMemberOrgPolicy"] = "OrgMemberOrgPolicy";
    SdPlatformPolicyCommonAliasesOrganization["OrgOwnerOrgPolicy"] = "OrgOwnerOrgPolicy";
    SdPlatformPolicyCommonAliasesOrganization["PublicOrgPolicy"] = "PublicOrgPolicy";
})(SdPlatformPolicyCommonAliasesOrganization = exports.SdPlatformPolicyCommonAliasesOrganization || (exports.SdPlatformPolicyCommonAliasesOrganization = {}));
/**
 * Common policy aliases - Utility
 */
var SdPlatformPolicyCommonAliasesUtility;
(function (SdPlatformPolicyCommonAliasesUtility) {
    SdPlatformPolicyCommonAliasesUtility["AdminUtilityPolicy"] = "AdminUtilityPolicy";
})(SdPlatformPolicyCommonAliasesUtility = exports.SdPlatformPolicyCommonAliasesUtility || (exports.SdPlatformPolicyCommonAliasesUtility = {}));
/**
* Common policy aliases - Platform
*/
var SdPlatformPolicyCommonAliasesPlatform;
(function (SdPlatformPolicyCommonAliasesPlatform) {
    SdPlatformPolicyCommonAliasesPlatform["AdminPlatformPolicy"] = "AdminPlatformPolicy";
})(SdPlatformPolicyCommonAliasesPlatform = exports.SdPlatformPolicyCommonAliasesPlatform || (exports.SdPlatformPolicyCommonAliasesPlatform = {}));
/**
 * Common policy aliases - Asset
 */
var SdPlatformPolicyCommonAliasesAsset;
(function (SdPlatformPolicyCommonAliasesAsset) {
    SdPlatformPolicyCommonAliasesAsset["AdminAssetPolicy"] = "AdminAssetPolicy";
})(SdPlatformPolicyCommonAliasesAsset = exports.SdPlatformPolicyCommonAliasesAsset || (exports.SdPlatformPolicyCommonAliasesAsset = {}));
/**
 * Permissions for models
 */
var SdPlatformPolicyPermissionsModel;
(function (SdPlatformPolicyPermissionsModel) {
    SdPlatformPolicyPermissionsModel["getRestModelPublic"] = "get_rest_model_public";
    SdPlatformPolicyPermissionsModel["getRestModelAdmin"] = "get_rest_model_admin";
    SdPlatformPolicyPermissionsModel["getRestModelOwner"] = "get_rest_model_owner";
    SdPlatformPolicyPermissionsModel["getTokenScopeGroupView"] = "get_token_scope_group_view";
    SdPlatformPolicyPermissionsModel["getTokenScopeGroupExport"] = "get_token_scope_group_export";
    SdPlatformPolicyPermissionsModel["getTokenScopeGroupOwner"] = "get_token_scope_group_owner";
    SdPlatformPolicyPermissionsModel["getTicket"] = "get_ticket";
    SdPlatformPolicyPermissionsModel["getTicketAuthor"] = "get_ticket_author";
    SdPlatformPolicyPermissionsModel["getTicketBackend"] = "get_ticket_backend";
    SdPlatformPolicyPermissionsModel["embedAccessDomains"] = "embed_access_domains";
    SdPlatformPolicyPermissionsModel["embedBackendSystems"] = "embed_backend_systems";
    SdPlatformPolicyPermissionsModel["embedBackendProperties"] = "embed_backend_properties";
    SdPlatformPolicyPermissionsModel["embedTags"] = "embed_tags";
    SdPlatformPolicyPermissionsModel["embedUser"] = "embed_user";
    SdPlatformPolicyPermissionsModel["embedDecoration"] = "embed_decoration";
    SdPlatformPolicyPermissionsModel["embedBookmark"] = "embed_bookmark";
    SdPlatformPolicyPermissionsModel["getSharingAll"] = "get_sharing_all";
    SdPlatformPolicyPermissionsModel["putSharingAll"] = "put_sharing_all";
    SdPlatformPolicyPermissionsModel["decryptTicket"] = "decrypt_ticket";
    SdPlatformPolicyPermissionsModel["createSavedState"] = "create_saved_state";
    SdPlatformPolicyPermissionsModel["queryAllSavedStates"] = "query_all_saved_states";
    SdPlatformPolicyPermissionsModel["getTokenScopeGroupAnalytics"] = "get_token_scope_group_analytics";
    SdPlatformPolicyPermissionsModel["getAnalyticsSession"] = "get_analytics_session";
    SdPlatformPolicyPermissionsModel["getAnalyticsComputation"] = "get_analytics_computation";
    SdPlatformPolicyPermissionsModel["uiBackendApi"] = "ui_backend_api";
    SdPlatformPolicyPermissionsModel["uiDesktopClients"] = "ui_desktop_clients";
    SdPlatformPolicyPermissionsModel["uiDirectEmbedding"] = "ui_direct_embedding";
    SdPlatformPolicyPermissionsModel["uiIframeEmebedding"] = "ui_iframe_embedding";
    SdPlatformPolicyPermissionsModel["uiUnlistedModels"] = "ui_unlisted_models";
    SdPlatformPolicyPermissionsModel["updateAll"] = "update_all";
    SdPlatformPolicyPermissionsModel["updateOwner"] = "update_owner";
    SdPlatformPolicyPermissionsModel["updateOrganization"] = "update_organization";
    SdPlatformPolicyPermissionsModel["delete"] = "delete";
    SdPlatformPolicyPermissionsModel["embedOrganization"] = "embed_organization";
    SdPlatformPolicyPermissionsModel["getTokenScopeFileDownload"] = "get_token_scope_file_download";
})(SdPlatformPolicyPermissionsModel = exports.SdPlatformPolicyPermissionsModel || (exports.SdPlatformPolicyPermissionsModel = {}));
/**
 * Permissions for organizations
 */
var SdPlatformPolicyPermissionsOrganization;
(function (SdPlatformPolicyPermissionsOrganization) {
    SdPlatformPolicyPermissionsOrganization["getRestModelPublic"] = "get_rest_model_public";
    SdPlatformPolicyPermissionsOrganization["getRestModelOrganizationMember"] = "get_rest_model_organization_member";
    SdPlatformPolicyPermissionsOrganization["getRestModelOrganizationAdmin"] = "get_rest_model_organization_admin";
    SdPlatformPolicyPermissionsOrganization["getRestModelOrganizationOwner"] = "get_rest_model_organization_owner";
    SdPlatformPolicyPermissionsOrganization["getRestModelAdmin"] = "get_rest_model_admin";
    SdPlatformPolicyPermissionsOrganization["updateOrganizationAdmin"] = "update_organization_admin";
    SdPlatformPolicyPermissionsOrganization["updateOrganizationOwner"] = "update_organization_owner";
    SdPlatformPolicyPermissionsOrganization["updateAll"] = "update_all";
    SdPlatformPolicyPermissionsOrganization["embedAccessDomains"] = "embed_access_domains";
    SdPlatformPolicyPermissionsOrganization["embedMembers"] = "embed_members";
    SdPlatformPolicyPermissionsOrganization["embedChargebeeCustomer"] = "embed_chargebee_customer";
    SdPlatformPolicyPermissionsOrganization["embedChargebeeSubscription"] = "embed_chargebee_subscription";
    SdPlatformPolicyPermissionsOrganization["embedChargebeePlan"] = "embed_chargebee_plan";
    SdPlatformPolicyPermissionsOrganization["embedChargebeeAddons"] = "embed_chargebee_addons";
    SdPlatformPolicyPermissionsOrganization["create"] = "create";
    SdPlatformPolicyPermissionsOrganization["delete"] = "delete";
    SdPlatformPolicyPermissionsOrganization["queryModelSessions"] = "query_model_sessions";
    SdPlatformPolicyPermissionsOrganization["embedUsedCredits"] = "embed_used_credits";
    SdPlatformPolicyPermissionsOrganization["embedBackendSystem"] = "embed_backend_system";
    SdPlatformPolicyPermissionsOrganization["getTokenScopeGroupAnalytics"] = "get_token_scope_group_analytics";
})(SdPlatformPolicyPermissionsOrganization = exports.SdPlatformPolicyPermissionsOrganization || (exports.SdPlatformPolicyPermissionsOrganization = {}));
/**
 * Permissions for users
 */
var SdPlatformPolicyPermissionsUser;
(function (SdPlatformPolicyPermissionsUser) {
    SdPlatformPolicyPermissionsUser["getRestModelPublicMinimal"] = "get_rest_model_public_minimal";
    SdPlatformPolicyPermissionsUser["getRestModelPublic"] = "get_rest_model_public";
    SdPlatformPolicyPermissionsUser["getRestModelSelf"] = "get_rest_model_self";
    SdPlatformPolicyPermissionsUser["getRestModelAdmin"] = "get_rest_model_admin";
    SdPlatformPolicyPermissionsUser["embedBackendSystem"] = "embed_backend_system";
    SdPlatformPolicyPermissionsUser["embedChargebeeCustomer"] = "embed_chargebee_customer";
    SdPlatformPolicyPermissionsUser["embedChargebeeSubscription"] = "embed_chargebee_subscription";
    SdPlatformPolicyPermissionsUser["embedChargebeePlan"] = "embed_chargebee_plan";
    SdPlatformPolicyPermissionsUser["embedChargebeeAddons"] = "embed_chargebee_addons";
    SdPlatformPolicyPermissionsUser["embedGlobalAccessDomains"] = "embed_global_access_domains";
    SdPlatformPolicyPermissionsUser["embedUsedCredits"] = "embed_used_credits";
    SdPlatformPolicyPermissionsUser["updateDefaultBackendSystem"] = "update_default_backend_system";
    SdPlatformPolicyPermissionsUser["updateSelf"] = "update_self";
    SdPlatformPolicyPermissionsUser["updateAll"] = "update_all";
    SdPlatformPolicyPermissionsUser["queryByUsername"] = "query_by_username";
    SdPlatformPolicyPermissionsUser["queryByFirstName"] = "query_by_first_name";
    SdPlatformPolicyPermissionsUser["queryByLastName"] = "query_by_last_name";
    SdPlatformPolicyPermissionsUser["queryByAll"] = "query_by_all";
    SdPlatformPolicyPermissionsUser["findByQuery"] = "find_by_query";
    SdPlatformPolicyPermissionsUser["queryAllSavedStates"] = "query_all_saved_states";
    SdPlatformPolicyPermissionsUser["getSharingAll"] = "get_sharing_all";
    SdPlatformPolicyPermissionsUser["queryModelsByAll"] = "query_models_by_all";
    SdPlatformPolicyPermissionsUser["queryModelSessions"] = "query_model_sessions";
    SdPlatformPolicyPermissionsUser["delete"] = "delete";
    SdPlatformPolicyPermissionsUser["queryImagesByAll"] = "query_images_by_all";
    SdPlatformPolicyPermissionsUser["queryByEmailExact"] = "query_by_email_exact";
    SdPlatformPolicyPermissionsUser["embedOrganization"] = "embed_organization";
    SdPlatformPolicyPermissionsUser["getRestModelOrganization"] = "get_rest_model_organization";
    SdPlatformPolicyPermissionsUser["getTokenScopeGroupAnalytics"] = "get_token_scope_group_analytics";
})(SdPlatformPolicyPermissionsUser = exports.SdPlatformPolicyPermissionsUser || (exports.SdPlatformPolicyPermissionsUser = {}));
/**
 * Permissions for saved states
 */
var SdPlatformPolicyPermissionsSavedState;
(function (SdPlatformPolicyPermissionsSavedState) {
    SdPlatformPolicyPermissionsSavedState["getRestModelPublic"] = "get_rest_model_public";
    SdPlatformPolicyPermissionsSavedState["getRestModelAdmin"] = "get_rest_model_admin";
    SdPlatformPolicyPermissionsSavedState["getRestModelOwner"] = "get_rest_model_owner";
    SdPlatformPolicyPermissionsSavedState["delete"] = "delete";
    SdPlatformPolicyPermissionsSavedState["update"] = "update";
    SdPlatformPolicyPermissionsSavedState["getSharingAll"] = "get_sharing_all";
    SdPlatformPolicyPermissionsSavedState["putSharingAll"] = "put_sharing_all";
    SdPlatformPolicyPermissionsSavedState["getRestModelMinimal"] = "get_rest_model_minimal";
})(SdPlatformPolicyPermissionsSavedState = exports.SdPlatformPolicyPermissionsSavedState || (exports.SdPlatformPolicyPermissionsSavedState = {}));
/**
 * Permissions for diverse utilities (domains, tags, notifications)
 */
var SdPlatformPolicyPermissionsUtility;
(function (SdPlatformPolicyPermissionsUtility) {
    SdPlatformPolicyPermissionsUtility["domainGetRestModelAdmin"] = "domain_get_rest_model_admin";
    SdPlatformPolicyPermissionsUtility["domainCreate"] = "domain_create";
    SdPlatformPolicyPermissionsUtility["domainPatch"] = "domain_patch";
    SdPlatformPolicyPermissionsUtility["domainDelete"] = "domain_delete";
    SdPlatformPolicyPermissionsUtility["tagGetRestModelAdmin"] = "tag_get_rest_model_admin";
    SdPlatformPolicyPermissionsUtility["tagDelete"] = "tag_delete";
    SdPlatformPolicyPermissionsUtility["notificationCreate"] = "notification_create";
    SdPlatformPolicyPermissionsUtility["notificationDelete"] = "notification_delete";
})(SdPlatformPolicyPermissionsUtility = exports.SdPlatformPolicyPermissionsUtility || (exports.SdPlatformPolicyPermissionsUtility = {}));
/**
 * Permissions related to the platform backend (actions, geometry backend systems, logs, policies)
 */
var SdPlatformPolicyPermissionsPlatform;
(function (SdPlatformPolicyPermissionsPlatform) {
    SdPlatformPolicyPermissionsPlatform["actionsRunAll"] = "actions_run_all";
    SdPlatformPolicyPermissionsPlatform["apiClientQuery"] = "api_client_query";
    SdPlatformPolicyPermissionsPlatform["apiClientCreate"] = "api_client_create";
    SdPlatformPolicyPermissionsPlatform["apiClientPatch"] = "api_client_patch";
    SdPlatformPolicyPermissionsPlatform["apiClientDelete"] = "api_client_delete";
    SdPlatformPolicyPermissionsPlatform["backendSystemQuery"] = "backend_system_query";
    SdPlatformPolicyPermissionsPlatform["backendSystemCreate"] = "backend_system_create";
    SdPlatformPolicyPermissionsPlatform["backendSystemPatch"] = "backend_system_patch";
    SdPlatformPolicyPermissionsPlatform["backendSystemDelete"] = "backend_system_delete";
    SdPlatformPolicyPermissionsPlatform["backendSystemToken"] = "backend_system_token";
    SdPlatformPolicyPermissionsPlatform["httpLogsQUery"] = "http_logs_query";
    SdPlatformPolicyPermissionsPlatform["policyQuery"] = "policy_query";
    SdPlatformPolicyPermissionsPlatform["policyGet"] = "policy_get";
    SdPlatformPolicyPermissionsPlatform["policyCreate"] = "policy_create";
    SdPlatformPolicyPermissionsPlatform["policyPatch"] = "policy_patch";
    SdPlatformPolicyPermissionsPlatform["policyDelete"] = "policy_delete";
})(SdPlatformPolicyPermissionsPlatform = exports.SdPlatformPolicyPermissionsPlatform || (exports.SdPlatformPolicyPermissionsPlatform = {}));
/**
 * Permissions related to assets
 */
var SdPlatformPolicyPermissionsAsset;
(function (SdPlatformPolicyPermissionsAsset) {
    SdPlatformPolicyPermissionsAsset["getRestModelPublic"] = "get_rest_model_public";
    SdPlatformPolicyPermissionsAsset["getRestModelOwner"] = "get_rest_model_owner";
    SdPlatformPolicyPermissionsAsset["getRestModelAdmin"] = "get_rest_model_admin";
    SdPlatformPolicyPermissionsAsset["embedModels"] = "embed_models";
    SdPlatformPolicyPermissionsAsset["embedUser"] = "embed_user";
    SdPlatformPolicyPermissionsAsset["updateOwner"] = "update_owner";
    SdPlatformPolicyPermissionsAsset["updateAll"] = "update_all";
    SdPlatformPolicyPermissionsAsset["delete"] = "delete";
})(SdPlatformPolicyPermissionsAsset = exports.SdPlatformPolicyPermissionsAsset || (exports.SdPlatformPolicyPermissionsAsset = {}));
//# sourceMappingURL=SdPlatformPolicyCommons.js.map